/**
 * OnayMetniParcalari.jsx — Onay Metinleri liste ve ayrıntı sayfalarının ortak parçaları (backlog #536, 2026-10-21).
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { DIL, DILLER, HEDEF } from "../../../services/onayMetniService";

export const DIL_KODU = { [DIL.TR]: "TR", [DIL.EN]: "EN" };

/** Bir metnin gösterilecek başlığı: arayüz dilindeki, yoksa öteki; yayınlanmamışsa taslağınki. */
export function metinBasligi(m, dil) {
  const sira = dil === "en" ? ["En", "Tr"] : ["Tr", "En"];
  for (const donem of ["guncel", "taslak"]) {
    for (const d of sira) {
      const b = m[`${donem}Baslik${d}`];
      if (b) return b;
    }
  }
  return null;
}

/** Metnin bilinen bütün başlıkları (güncel ve taslak, TR ve EN): aramada hangi dilde yazılırsa yazılsın bulunsun. */
export function tumBasliklar(m) {
  return ["guncelBaslikTr", "guncelBaslikEn", "taslakBaslikTr", "taslakBaslikEn"].map((a) => m[a]).filter(Boolean);
}

/** TR / EN işaretleri: dilin gövdesi varsa yeşil, yoksa üstü çizili kesikli. `diller` = [1, 2] biçiminde var olanlar. */
export function DilIsaretleri({ diller }) {
  const { t } = useTranslation("ayarlar");
  return (
    <span className="d-inline-flex gap-1">
      {DILLER.map((d) => {
        const var_ = diller.includes(d);
        return (
          <span key={d} className={`onay-isaret ${var_ ? "onay-isaret--var" : "onay-isaret--yok"}`}
            title={var_ ? t("onayMetinleri.dilVar", { dil: DIL_KODU[d] }) : t("onayMetinleri.dilYok", { dil: DIL_KODU[d] })}>
            {DIL_KODU[d]}
          </span>
        );
      })}
    </span>
  );
}

/** Kitle (hedef) adı: 1 Kullanıcı, 2 Kişi, 3 Taahhütname, 4 Talep metni. */
export function hedefAdi(t, hedef) {
  if (hedef === HEDEF.KISI) return t("onayMetinleri.hedefKisi");
  if (hedef === HEDEF.TAAHHUTNAME) return t("onayMetinleri.hedefTaahhutname");
  if (hedef === HEDEF.TALEP) return t("onayMetinleri.hedefTalep");
  return t("onayMetinleri.hedefKullanici");
}

/** Metnin güncel sürümünü kaç kişi onayladı: kişi metninde kişi onayları; taahhütname proje sayfasında, talep metni talebin kendisinde onaylandığı için yok (null). */
export function onaySayisi(m) {
  if (m.hedef === HEDEF.TAAHHUTNAME || m.hedef === HEDEF.TALEP) return null;
  return Number((m.hedef === HEDEF.KISI ? m.guncelKisiOnaySayisi : m.guncelOnaySayisi) ?? 0);
}

/** ISO tarihi (saat dilimli) yerel biçimde; okunamazsa "—". */
export function tarihYaz(iso, localeTag) {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString(localeTag);
}
